import { Chapter } from "../models/Chapter";

// Searches Chapter titles and returns the ones matching the input query.
export const searchChapters = (query: string, chapters: Chapter[]) => {
  const normalizedQuery = query.toLowerCase();

  const foundActivities: Chapter[] = chapters.filter((c) =>
    c.title.toLowerCase().includes(normalizedQuery)
  );

  return foundActivities;
};
